import { Typography, Chip, makeStyles } from "@material-ui/core";
import moment from "moment";
import { WithTooltip } from "@components";
import {
  BookingSupportTagStatusFragment,
  useBookingProfile_GetTagsQuery
} from "@bonliva-crm/graphql";
import { ThemeType } from "@theme";
import CommentIcon from "@material-ui/icons/Comment";

type Props = {
  tags: BookingSupportTagStatusFragment[];
  comment?: string;
};

const BookingKitTagStatusCol = ({ tags, comment }: Props) => {
  const classes = useStyles({});
  const { data: tagsData } = useBookingProfile_GetTagsQuery({
    fetchPolicy: "cache-first"
  });

  const tagsMap =
    tagsData?.config.bookingTags.reduce(
      (acc, tag) => ({ ...acc, [tag.code]: tag }),
      {}
    ) || {};

  return (
    <div className={classes.wrap}>
      {tags?.map((x, i) => {
        const tagOption = tagsMap[x.tag];

        if (!tagOption || !tagOption?.bookingKit) {
          return null; // Skip if tag is not found in tagsMap
        }
        return (
          <Chip
            key={i}
            label={
              <WithTooltip
                title={
                  <>
                    {tagOption.label}
                    <Typography variant={"caption"} display={"block"}>
                      {x.setBy?.Name}
                    </Typography>{" "}
                    <Typography variant={"caption"}>
                      {moment(x?.setOn).format("YYYY-MM-DD HH:mm")}
                    </Typography>
                  </>
                }
              >
                <Typography
                  variant={"caption"}
                  display={"block"}
                  noWrap
                  className={classes.caption}
                >
                  {tagOption?.label}
                </Typography>
              </WithTooltip>
            }
            variant="outlined"
            icon={
              <span
                className={classes.icon}
                style={{ backgroundColor: tagOption?.color }}
              />
            }
          />
        );
      })}
      {comment && (
        <WithTooltip title={comment}>
          <CommentIcon fontSize={"small"} />
        </WithTooltip>
      )}
    </div>
  );
};

const useStyles = makeStyles((theme: ThemeType) => ({
  wrap: {
    display: "flex",
    flexWrap: "wrap",
    gap: 3,
    padding: "3px 0",
    alignItems: "center"
  },
  caption: { maxWidth: 120 },
  icon: {
    display: "inline-block",
    width: 16,
    height: 16,
    borderRadius: "50%"
  }
}));

export default BookingKitTagStatusCol;
